














import { Component, Prop, Vue } from 'vue-property-decorator';
import { app } from '@store/modules/app';
import { Component as ComponentType } from 'vue';
import DesktopNav from '@components/header/navigation/desktop/desktop-nav.vue';
import DesktopNavAuth from '@components/header/navigation/desktop/desktop-nav-auth.vue';
import { HeaderStyle } from 'types/header';
import MobileNav from '@components/header/navigation/mobile/mobile-nav.vue';
import MobileNavAuth from '@components/header/navigation/mobile/mobile-nav-auth.vue';

@Component({
	components: {
		DesktopNav,
		DesktopNavAuth,
		MobileNav,
		MobileNavAuth
	}
})
export default class AppHeader extends Vue {
	@Prop()
	transparentHeader!: boolean;

	@Prop()
	transparentHeaderDarkText!: boolean;

	appBasePath = process.env.VUE_APP_BASE_PATH;

	$refs!: {
		placeholderElem: HTMLElement;
	};

	isHovering = false;

	isScrolling = false;

	isTransparentDarkText = this.transparentHeader && this.transparentHeaderDarkText;

	stickyHeaderStyles: HeaderStyle = {
		logo: `${process.env.VUE_APP_CLOUDFRONT_DOMAIN}/interface/logo-hz-color.svg`,
		buttonClassLogin: '',
		buttonClassGetStarted: 'button-fundrise-orange',
		isSticky: true
	};

	defaultHeaderStyles: HeaderStyle = {
		logo: this.isTransparentDarkText
			? `${process.env.VUE_APP_CLOUDFRONT_DOMAIN}/interface/logo-hz-color.svg`
			: `${process.env.VUE_APP_CLOUDFRONT_DOMAIN}/interface/logo-hz-white.svg`,
		buttonClassLogin: this.isTransparentDarkText ? '' : 'button-ghost',
		buttonClassGetStarted: this.isTransparentDarkText ? 'button-fundrise-orange' : 'button-white',
		isSticky: false
	};

	get isSticky(): boolean {
		return !this.transparentHeader || this.isScrolling || this.isHovering;
	}

	get headerStyle(): HeaderStyle {
		return this.isSticky ? this.stickyHeaderStyles : this.defaultHeaderStyles;
	}

	private handleIntersect(entries: Array<IntersectionObserverEntry>): void {
		this.isScrolling = entries[0].intersectionRatio !== 1;
	}

	get navComponent(): ComponentType {
		if (app.screenSize === 'DESKTOP') {
			if (app.isAuthenticated) {
				return DesktopNavAuth;
			} else {
				return DesktopNav;
			}
		} else {
			if (app.isAuthenticated) {
				return MobileNavAuth;
			} else {
				return MobileNav;
			}
		}
	}

	observer: IntersectionObserver = new IntersectionObserver(this.handleIntersect, { threshold: 1 });

	mounted(): void {
		this.observer.observe(this.$refs.placeholderElem);
	}
}
